module.exports = __webpack_public_path__ + "static/img/coupon_bg_en.27a9dcd2.png";